const portfolioItems = [
    {
        title: "BRF Strindbergshuset",
        category: "Web Development",
        description: "Full-stack website solution for the housing facility Strindbergshuset",
        technologies: ["React", "ASP.NET", "MySQL"],
        status: "Completed",
    },
    {
        title: "Introteknik AB",
        category: "Web Development",
        description: "Full-stack website solution for the industrial company Introteknik AB",
        technologies: ["React", "Node.js", "Express", "MongoDB"],
        status: "In Progress",
    },
    {
        title: "PowerWatch",
        category: "IoT Solutions",
        description: "In-house solution for monitoring and optimizing energy consumption in real-time.",
        technologies: ["React", "Node.js", "Express", "Docker", "MongoDB", "RestAPI", "IoT"],
        status: "In Progress",
    },
    {
        title: "CarbonEdge",
        category: "Node Infrastructure",
        description: "Cutting edge server infrastructure, redefining cloud hosting with distributed edge computing systems.",
        technologies: ["Docker", "Kubernetes", "AWS", "DNS", "Cloudhosting"],
        status: "In Progress",
    },
    {
        title: "bebis.se",
        category: "Web Development",
        description: "Full-stack website solution for the baby product company Bebis.se",
        technologies: ["React", "Node.js", "Express", "MongoDB"],
        status: "Completed",
    },
    {
        title: "Slabs Steel Systems",
        category: "Software Development",
        description: "Slabs Steel analysis software, implemented on industrial scale for multiple international steel companies.",
        technologies: ["C#", "WPF", "SQL Server", ".NET", "OpenCV", "Image Processing"],
        status: "Completed",
    }
];

export default function Portfolio() {
    return (
        <section className="section">
            <span className="section-label">Portfolio</span>
            <h2>Problems solved, IT forgotten</h2>
            <p className="section-desc">
                Real projects where clients forgot about the tech headaches and focused on their goals — because we handled the rest.
            </p>

            <div className="card-grid cols-3">
                {portfolioItems.map((item, i) => (
                    <div className="card-item" key={i} data-aos="fade-up" data-aos-delay={i * 100}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1rem', gap: '0.5rem' }}>
                            <span className="tag tag-category">{item.category}</span>
                            <span className={`tag ${item.status === 'Completed' ? 'tag-completed' : 'tag-progress'}`}>
                                {item.status}
                            </span>
                        </div>
                        <h3>{item.title}</h3>
                        <p className="card-text" style={{ marginBottom: '1.25rem' }}>{item.description}</p>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.35rem', marginTop: 'auto' }}>
                            {item.technologies.map((tech, j) => (
                                <span className="tech-tag" key={j}>{tech}</span>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
